// extracted by mini-css-extract-plugin
export default {"action-wrapper":"style_action-wrapper__34zvJ"};